import React from 'react';
import { PanelHeader as PanelHeaderAtom } from '../../../atoms';

interface Props {
    className?: string;
    children?: JSX.Element | JSX.Element[];
    bgNone?: boolean;
}

function PanelHeader({ children, className, bgNone }: Props) {

    return (
        <>
            <PanelHeaderAtom className={className} bgNone={bgNone}>
                {children}
            </PanelHeaderAtom>
        </>
    )
}

PanelHeader.displayName = 'PanelHeader';

export default PanelHeader;